var component = {};

if (process.browser) {
    component = require('./dropzone');
}
component.name = 'dropzone';
component.render = function (createElement) {
    var that = this._self;
    return createElement('div', {
        props: that.props,
        attrs: {
            class: 'vue-dropzone dropzone',
            id: that.id || ''
        },
        ref: 'dropzoneElement'
    }, this.$slots.default);
};

module.exports = component;


//////////////////
// WEBPACK FOOTER
// ./src/components/shared/dropzone/index.js
// module id = ./src/components/shared/dropzone/index.js
// module chunks = 0 1 2 3